<app-logo-card-container
  cardWidth="492px"
  tintMode="strip"
  backgroundImage="url('/images/backgrounds/08.jpg')"
  title="Welcome to Vanhu Tech"
  subTitle="Social Impact. Redefined."
>
  <ng-container cardContent>
    <h4>Welcome to Vanhu Tech!</h4>

    <p>
      We're building a Social Impact Ecosystem where <i>impact drives funding</i> instead of funding
      driving decisions. Where social implementers like you define solutions based on community
      needs, then get matched with aligned investors who share your goals. We are still building the
      system, so currently, pre-registration is only open to South African nonprofit organisations;
      other African countries to follow. This isn't another platform you'll use someday—this is part
      of a collective movement transforming how social impact works across Africa.
    </p>

    <p>After registration you'll receive:</p>

    <ul>
      <li>Monthly updates with funding opportunities and relevant events</li>
      <li>Participation in surveys that build our collective voice</li>
      <li>Access to our fireside chats and webinars with subject experts</li>
      <li>Priority access when our full Ecosystem launches</li>
    </ul>

    <p>
      Thank you for the work that you do. We look forward to learning more about your organisation
      and growing with you. And thank you for joining us on this journey; we're glad you're here!
    </p>

    <p>- Cristianne Wendler, Co-founder and CEO</p>
  </ng-container>
  <ng-container cardActions>
    @if (error === 'unknown') {
      <div class="error-and-try-again">
        <mat-error
          >Something went wrong. Please try again in a few moments. If the problem persists, please
          send an email to <a href="mailto:info@vanhu-tech.org">info&#64;vanhutech.org</a>.
        </mat-error>
      </div>
    } @else if (error === 'interaction_in_progress') {
      <div class="error-and-try-again">
        <mat-error
          >A login popup is already open. Please check your browser and complete the login there. If
          you have already closed the popup or nothing is happening,
          <a href="#" (click)="forceRestartLogin(); $event.preventDefault()">click here</a> to try
          again.
        </mat-error>
      </div>
    }

    <button mat-flat-button (click)="logIn()">Log In</button>
    <button mat-stroked-button (click)="signUp()">Create Profile</button>
  </ng-container>
</app-logo-card-container>
